import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Skeleton from '../../../Common/Skeleton/Skeleton';
import s from './UpcomingBookingSkeleton.css'

const BookingCardSkeleton = () => (
    <div className={s.bookingSkeletonCard}>
        <Skeleton className={s.bookingSkeletonCardImg} />
        <div className={s.bookingSkeletonCardInfoBox}>
            <div className={s.bookingSkeletonCardInfoLsContainer}>
                <Skeleton className={s.bookingSkeletonCardInfoTitle} />
                <Skeleton className={s.bookingSkeletonCardInfoDesc} />
                <Skeleton className={cx(s.bookingSkeletonCardInfoDesc, s.bookingSkeletonCardInfoLargeDesc)} />
                <Skeleton className={cx(s.bookingSkeletonCardInfoDesc, s.bookingSkeletonCardInfoSmallDesc)} />
            </div>
            <div className={s.bookingSkeletonCardInfoRsContainer}>
                <Skeleton className={s.bookingSkeletonCardInfoIdTitle} />
                <Skeleton className={s.bookingSkeletonCardInfoIdDesc} />
            </div>
        </div>
    </div>
);

function UpcomingBookingSkeleton({ isBooking }) {
    return (
        <div className={cx(s.bookingSkeletonCardContainer, !isBooking && s.bookingSkeletonCardSpace)}>
            <Skeleton className={s.bookingSkeletonCardTitle} />
            {isBooking ? (
                <div className={s.bookingSkeletonCardListContainer}>
                    {Array.from({ length: 2 }).map((_, index) => (
                        <BookingCardSkeleton key={index} />
                    ))}
                </div>
            ) : (
                <BookingCardSkeleton />
            )}
        </div>
    );
}

export default withStyles(s)(UpcomingBookingSkeleton);
